<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="academyInvitations"
  >
    <div class="align-items-baseline display-flex-row m-filters-and-actions">
      <form
        autocomplete="off"
        class="align-items-baseline m-form-row"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomInputPrimary
          v-model="simpleFilter.email"
          :disabled="pagination.showLoadingState"
          name="email"
          :placeholder="$t('mEditionAcademyInvitations.input.email.placeholder')"
          type="email"
          wrapperClass="a-input-wrapper-row"
          @input="searchSimpleFilter"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reload"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <AtomButtonSecondary
        :button-secondary="buttonSecondary.create"
        :disabled="pagination.showLoadingState"
        @showModal="$modal.showModal"
      />
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="invitaciones.length">
          <th
            class="text-align-left"
            width="21%"
          >
            {{ $t('mEditionAcademyInvitations.table.thEmail') }}
          </th>
          <th
            class="text-align-center"
            width="18%"
          >
            {{ $t('mEditionAcademyInvitations.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="18%"
          >
            {{ $t('mEditionAcademyInvitations.table.thDateVenc') }}
          </th>
          <th
            class="text-align-center"
            width="15%"
          >
            {{ $t('mEditionAcademyInvitations.table.thRoles') }}
          </th>
          <th
            class="text-align-center"
            width="8%"
          >
            {{ $t('mEditionAcademyInvitations.table.thUrl') }}
          </th>
          <th
            class="text-align-center"
            width="8%"
          >
            {{ $t('mEditionAcademyInvitations.table.thData') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionAcademyInvitations.table.thResend') }}
          </th>
        </tr>
        <tr
          v-for="(invitacion, index) in invitaciones"
          :key="index"
        >
          <td class="text-align-left">
            <span class="display-block ellipsis font-weight-regular text-color-success">
              {{ invitacion.email }}
            </span>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment(invitacion.fecha_creacion).format('D MMM YYYY HH:mm') }}
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment(invitacion.fecha_vencida).format('D MMM YYYY HH:mm') }}
          </td>
          <td class="text-align-center">
            {{ $filters.getActorValue(invitacion.actor_tipo, 'name') }}
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.link"
              :element="invitacion"
              @copyUrl="copyUrl(invitacion.invitacion)"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.data"
              :element="invitacion"
              @showModal="$modal.showModal"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.resend"
              :disabled="requests.reenviarInvitacionPendiente.isRequested &&
                requests.reenviarInvitacionPendiente.itemLoading !== invitacion.invitacion"
              :element="invitacion"
              :show-loading="requests.reenviarInvitacionPendiente.isRequested &&
                requests.reenviarInvitacionPendiente.itemLoading === invitacion.invitacion"
              @reenviarInvitacionPendiente="reenviarInvitacionPendiente(invitacion.invitacion)"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { validateEmail } from '@/plugins/validation/validators'

export default {
  name: 'MoleculeEditionAcademyInvitations',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academiaId: '',

      buttonIconRounded: {
        data: {
          class: 'a-button-secondary a-button-academy-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionAcademyInvitationsModalData',
          icon: 'fas fa-clipboard-list',
          method: 'showModal',
          tooltip: this.$t('mEditionAcademyInvitations.buttonIconRounded.dataTooltip'),
          type: 'button'
        },

        link: {
          class: 'a-button-secondary a-button-academy-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-link',
          method: 'copyUrl',
          tooltip: this.$t('mEditionAcademyInvitations.buttonIconRounded.linkTooltip'),
          type: 'button'
        },

        resend: {
          class: 'a-button-secondary a-button-academy-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-paper-plane',
          method: 'reenviarInvitacionPendiente',
          tooltip: this.$t('mEditionAcademyInvitations.buttonIconRounded.resendTooltip'),
          type: 'button'
        }
      },

      buttonSecondary: {
        create: {
          class: 'a-button-academy-secondary a-button-side',
          component: 'MoleculeEditionAcademyInvitationsModalCreate',
          icon: 'fas fa-paper-plane',
          method: 'showModal',
          text: this.$t('mEditionAcademyInvitations.buttonSecondary.createText'),
          type: 'button'
        },

        reload: {
          class: 'a-button-academy-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionAcademyInvitations.buttonSecondary.reloadTooltip'),
          type: 'button'
        }
      },

      filter: {
        email: '',
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        tipo: ''
      },

      invitaciones: [],

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      requests: {
        reenviarInvitacionPendiente: {
          itemLoading: '',
          isRequested: false
        }
      },

      showLoadingState: true,

      simpleFilter: {
        email: '',
        tipo: ''
      }
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.readAcademiaInvitacionesPendiente()
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.readAcademiaInvitacionesPendiente()
  },

  methods: {
    copyUrl (invitacionId) {
      const elm = document.createElement('textarea')
      elm.value = `${this.$utils.getMarketPlaceDomain().replace('/academia', '')}/aceptar-invitacion/${invitacionId}`
      document.body.appendChild(elm)
      elm.select()
      document.execCommand('copy')
      document.body.removeChild(elm)
    },

    readAcademiaInvitacionesPendiente () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('academia', 'readAcademiaInvitacionesPendiente', {}, [this.academiaId], this.filter)
          .then(response => {
            console.log(response.data)
            this.invitaciones = response.data.invitaciones
            this.pagination.currentQuantity = this.invitaciones.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
          .catch(error => {
            console.log(error)
            this.usuarios = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
      }
    },

    reenviarInvitacionPendiente (invitacionId) {
      if (!this.requests.reenviarInvitacionPendiente.isRequested) {
        this.requests.reenviarInvitacionPendiente.isRequested = true
        this.requests.reenviarInvitacionPendiente.itemLoading = invitacionId
        this.$services.read('academia', 'reenviarInvitacionPendiente', {}, [invitacionId])
          .then(response => {
            this.$alerts.pushAlert('mEditionAcademyInvitations', 'reenviarInvitacionPendiente', 'success')
            this.requests.reenviarInvitacionPendiente.isRequested = false
            this.readAcademiaInvitacionesPendiente()
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAcademyInvitations', 'reenviarInvitacionPendiente', 'error', 'a-alert-danger')
            this.requests.reenviarInvitacionPendiente.isRequested = false
          })
      }
    },

    reloadListing () {
      this.resetSimpleFilter()
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        email: '',
        limite: 10,
        pagina: 1
      }
    },

    resetSimpleFilter () {
      this.simpleFilter = {
        email: ''
      }
    },

    searchSimpleFilter () {
      if (validateEmail(this.simpleFilter.email) ||
        this.simpleFilter.email === '') {
        this.resetAdvancedFilter()
        this.filter.email = this.simpleFilter.email
        this.setPaginationCurrentPage(1)
      }
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readAcademiaInvitacionesPendiente()
    }
  }
}
</script>
